var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('h4',{staticClass:"mb-0 bold-title"},[_vm._v(_vm._s(_vm.pageTitle))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"mb-primary"},[_c('app-tab',{key:_vm.activeTab,attrs:{"tabs":_vm.tabBase,"active-tab":_vm.activeTab,"type":"horizontal"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }